<template>
  <el-dialog
    :title="$t('c.audit.myAuditLog')"
    width="70%"
    :visible.sync="showDialog"
    @close="handleClose"
    v-dialogDrag
  >
    <el-header class="main-body-search">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="pager.fuzzyText"
            :placeholder="$t('c.fuzzySearch')"
            @keyup.enter.native="searchMain(1)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchMain(1)"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="main-body-table">
      <el-table :data="mainTableData" @sort-change="sortChange">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column
          prop="itemCode"
          :label="$t('c.audit.operateType')"
          width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ $t(`c.${scope.row.itemCode}`) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="clientType"
          :label="$t('c.audit.clientType')"
          width="90"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="operateTime"
          :label="$t('c.audit.operateTime')"
          width="170"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="ipAddr"
          :label="$t('c.audit.ipAddr')"
          width="120"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="userAccount"
          :label="$t('c.audit.operator')"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="operationStatus"
          :label="$t('c.result')"
          width="90"
          sortable="custom"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.operationStatus === 'success' ? 'success' : 'danger'
              "
              disable-transitions
              >{{ $t(`c.${scope.row.operationStatus}`) }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('c.audit.operation')"
          sortable="custom"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.operationStatus === 'success' ? 'success' : 'danger'
              "
              disable-transitions
              >{{ scope.row.operation }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具条-->
      <el-pagination
        class="main-body-table-page"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="pager.current"
        :page-size="pager.size"
        :total="total"
      >
      </el-pagination>
    </el-main>
  </el-dialog>
</template>

<script>
import { selectPageOfMy } from '../api/DashBoard'
export default {
  name: 'baseMyAuditLogComp',
  // 组件属性对象
  props: {
    // 同步更新父对象的属性
    isVisible: Boolean
  },
  // 页面首次加载数据
  mounted() {
    this.searchMain(1)
  },
  data() {
    return {
      showDialog: true,
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10,
        fuzzyText: ''
      },
      // 主表数据
      mainTableData: []
    }
  },
  methods: {
    // 统一关闭方法
    handleClose() {
      this.showDialog = false
      // 子组件向父组件绑定的属性传值
      this.$emit('update:isVisible', this.showDialog)
    },
    /**
     * 分页模糊查询
     * @param current int 可选参数，查询指定页的数据
     * current: 不传值或传null/undefined/0，表示翻页
     * current: 大于等于1表示重新查询该页
     *    例如：更新某记录后重新加载当前页
     *    例如：删除某记录、查询文本框回车、查询按钮点击则传1，重新查询第1页
     */
    searchMain(current) {
      if (current && current >= 1) {
        // 重新查询该页
        this.pager.current = current
      }
      this.fetchMainTable()
    },
    /**
     * 模糊查询主表数据
     */
    fetchMainTable() {
      selectPageOfMy(this.pager).then(res => {
        let { data } = res
        this.total = data.total
        this.mainTableData = data.records
      })
    },
    /**
     * 点击列标题排序
     * @param column 点击排序的列对象
     */
    sortChange: function(column) {
      this.pager.prop = column.prop
      this.pager.order = column.order
      this.searchMain(1)
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size
      this.searchMain()
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current
      this.searchMain()
    }
  }
}
</script>

<style lang="scss"></style>
